<template>
  <div class="validator-deposit">
    <div class="title">
      Deposit
    </div>
    <div class="deposit-desc">
      Deposit 8 ETH to join as a delegated validator
    </div>
    
    <div class="inputs">
      <input type="text" placeholder="ETH AMOUNT" v-model="ethAmount" readOnly="true" />
      <div class="icon">
        <img src="../assets/eth.png" />
      </div>
    </div>
    <div class="desc">
      <template v-if="waitingStaked > 0">
        {{ waitingStaked }} ETH  is waiting to be staked, check <span class="pool" @click="jumpToPool">pool</span> status
      </template>
      <template v-else>
        {{ waitingPoolCount }}
        <template v-if="waitingPoolCount > 1">
          pools are
        </template>
        <template v-else>
          pool is
        </template>
         waiting to be matched in the queen
      </template>
    </div>
    <div class="items">
      <div class="eth-apr">
        <div class="item">
          <div class="item-title">
            Estimated APR
          </div>
          <div class="item-value">
            {{ apr }}
          </div>
        </div>

        <div class="item-joiner">
          +
        </div>

        <div class="item">
          <div class="item-title">
            Dropped FIS
          </div>
          <div class="item-value item-value-fis">
            3.75%
          </div>
        </div>
      </div>
    </div>

    <div class="deposit-btn" @click="deposit">
      Deposit
    </div>

  </div>
</template>

<script>
import { setTimeout } from 'timers';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import Web3Util from '../util/web3Util.js';
import NumberUtil from '../util/numberUtil.js';
import Rpc from '../util/rpc.js';

export default {
  name: 'validatorDeposit',
  data() {
    let lang = window.localStorage.getItem('lang');
    return {
      lang: lang,
      ethAmount: '8',
      clickBtn: false,
      waitingStaked: '--',
      waitingPoolCount: 0,
      apr: '--'
    }
  },

  methods: {

    jumpToPool() {
      this.$router.push({ name: 'ethpool', params: {source: 'validatorDeposit'}});
    },

    deposit() {
      if (this.clickBtn) {
        return;
      }

      if (!ethereum.selectedAddress) {
        Toast({ 
          message: 'Please connect metamask again!', 
          duration: 3000 
        });
        return;
      }

      this.clickBtn = true;

      let web3 = Web3Util.getWeb3();
      let contract = new web3.eth.Contract(Web3Util.getStafiNodeDepositAbi(), Web3Util.getStafiNodeDepositAddress(), {
        from: ethereum.selectedAddress
      });
      const amount = web3.utils.toWei(this.ethAmount.toString());

      Indicator.open('Loading...');

      contract.methods.deposit().send({value: amount}).then(result => {
        Indicator.close();
        this.clickBtn = false;

        if (result && result.status) {
          Toast({ 
            message: 'Deposit successfully', 
            duration: 3000 
          });
          setTimeout(() => {
            this.$emit('validatorDepositSuccess');
          }, 3300);
        } else {
          Toast({ 
            message: 'Error! Please try again', 
            duration: 3000 
          });
        }
      })
      .catch((error) => {
        Indicator.close();
        this.clickBtn = false;
        Toast({ 
          message: error.message, 
          duration: 3000 
        });
      });

    }
  },

  created() { 
    if (ethereum.selectedAddress) {
      let address = ethereum.selectedAddress;
      let web3 = Web3Util.getWeb3();
      let userDepositContract = new web3.eth.Contract(Web3Util.getStafiUserDepositAbi(), Web3Util.getStafiUserDepositAddress(), {
        from: address
      });

      userDepositContract.methods.getBalance().call().then(result => {
        let balance = parseFloat(web3.utils.fromWei(result, 'ether'));
        this.waitingStaked = NumberUtil.handleEthAmountToFixed(balance);
        if (this.waitingStaked <= 0) {
          let poolQueueContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolQueueAbi(), Web3Util.getStafiStakingPoolQueueAddress(), {
            from: address
          });

          poolQueueContract.methods.getLength(2).call().then(waitingPoolCount => {
            if (waitingPoolCount > 0) {
              this.waitingPoolCount = waitingPoolCount;
            }
          });

        }
      });
    }
    Rpc.fetchArp({arpType: 2}).then(result => {
      if (result.status == '80000') {
        if (result.data && result.data.validatorApr) {
          this.apr = result.data.validatorApr + '%';
        }
      } 
    });
  }
};
</script>

<style lang="scss">

.validator-deposit {

  .deposit-desc {
    font-size: 16px;
    color: #C4C4C4;
    margin-top: 10px;
  }

  .deposit-btn {
    cursor: pointer;
    margin-left: 361px;
    width: 110px;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    color: #23292F;
    font-weight: bold;
    background-color: #00F3AB;
    border-radius: 21px;
    text-align: center;
    margin-top: 102px;
  }

  .eth-apr {
    display: flex;

    .item-joiner {
      margin-left: 17px;
      margin-right: 17px;
      margin-top: 16px;
      font-size: 30px;
      font-weight: bold;
    }

    .item-value-fis {
      text-align: center;
    }
  }
}
  
</style>